import { render, staticRenderFns } from "./vacation.vue?vue&type=template&id=2326eec8&scoped=true&"
import script from "./vacation.vue?vue&type=script&lang=js&"
export * from "./vacation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2326eec8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2326eec8')) {
      api.createRecord('2326eec8', component.options)
    } else {
      api.reload('2326eec8', component.options)
    }
    module.hot.accept("./vacation.vue?vue&type=template&id=2326eec8&scoped=true&", function () {
      api.rerender('2326eec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/user/user_block/vacation.vue"
export default component.exports